import React, { PureComponent } from 'react';
import { oneOfType, string, bool, func, number } from 'prop-types';
import classnames from 'classnames';
import { Icons } from 'components';
import './Tag.scss';

export default class Tag extends PureComponent {
    static propTypes = {
        value: oneOfType([string, func]),
        label: oneOfType([string, number]).isRequired,
        url: string,
        /** it can be css color name, hexa, rgb or rgba */
        color: string,
        className: string,
        dataQa: string,
        deletable: bool,
        onClick: func,
    };

    static defaultProps = {
        className: null,
        dataQa: null,
        deletable: false,
        onClick: null,
        color: null,
        value: null,
        url: null,
    };

    handleClick = evt => {
        const { onClick, value } = this.props;
        if (onClick) {
            onClick(value, evt);
        }
    };

    render() {
        const { label, deletable, color, className, dataQa, url } = this.props;
        const rootClassnames = classnames('tag-root', className);

        const optionalProps = {};
        if (dataQa) {
            optionalProps['data-qa'] = dataQa;
        }

        return (
            <a
                href={url}
                className={rootClassnames}
                {...optionalProps}
                onClick={this.handleClick}
            >
                {deletable && (
                    <div
                        className="tag-root__delete-button"
                        data-button={`deleteTagButton:${label}`}
                    >
                        <Icons.Close
                            className="tag-root__delete-button__icon"
                            width="10"
                            height="10"
                        />
                    </div>
                )}

                {color && (
                    <div
                        className="tag-root__color"
                        style={{ backgroundColor: color }}
                    />
                )}

                <div className="tag-root__label" data-qa="tagLabelField">
                    {label}
                </div>
            </a>
        );
    }
}
